var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"car"},[_c('a',{on:{"click":_vm.toCar}},[_c('img',{attrs:{"src":require("../assets/img/carimg.png"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.count))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0259b085","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carshop.vue
// module id = 79
// module chunks = 1 2 3 4 5